import { render, staticRenderFns } from "./choose_me_contact.vue?vue&type=template&id=42113544&scoped=true&"
import script from "./choose_me_contact.vue?vue&type=script&lang=js&"
export * from "./choose_me_contact.vue?vue&type=script&lang=js&"
import style0 from "./choose_me_contact.vue?vue&type=style&index=0&id=42113544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42113544",
  null
  
)

export default component.exports